module.exports = __webpack_public_path__ + "static/media/dish_card7.156e4486.png";